import { createBrowserRouter } from 'react-router-dom';
import { Home } from '../pages/Home/Home';
import { CustomerFollowUp } from '../pages/CustomerFollowUp/CustomerFollowUp';
import { Settings } from '../pages/Settings/Settings';
import { HistoryList } from '../pages/History/HistoryList';
import { IgnoredRelances } from '../pages/IgnoredRelances/IgnoredRelances';
import { UpcomingRelances } from '../pages/UpcomingRelances/UpcomingRelances';
import { IGNORED_RELANCES_ROUTE, UPCOMING_RELANCES_ROUTE } from './paths';
import { NotFound } from '../pages/NotFound';
import { RootLayout } from '../pages/RootLayout';
import { SigninCallback } from '../pages/SigninCallback/SigninCallback';
import { SigninError } from '../pages/SigninError/SigninError';
import { SignoutCallback } from '../pages/SignoutCallback/SignoutCallback';
import { DevRankingPage } from '../pages/DevRanking/DevRankingPage';
import { AcombaPage } from '../pages/Acomba/AcombaPage';
import { DesktopAuth } from '../pages/DesktopAuth/DesktopAuth';

export const router = createBrowserRouter([
    // Auth callback / entry routes — outside RootLayout so they are always accessible.
    {
        path: '/desktop',
        element: <DesktopAuth />,
    },
    {
        path: '/signin-callback',
        element: <SigninCallback />,
    },
    {
        path: '/signin-error',
        element: <SigninError />,
    },
    {
        path: '/signout-callback',
        element: <SignoutCallback />,
    },
    {
        element: <RootLayout />,
        children: [
            {
                path: '/',
                element: <Home />,
            },
            {
                path: '/customer-follow-up/:id',
                element: <CustomerFollowUp />,
            },
            {
                path: IGNORED_RELANCES_ROUTE,
                element: <IgnoredRelances />,
            },
            {
                path: UPCOMING_RELANCES_ROUTE,
                element: <UpcomingRelances />,
            },
            {
                path: '/history',
                element: <HistoryList />,
            },
            {
                path: '/settings',
                element: <Settings />,
            },
            {
                path: '/acomba',
                element: <AcombaPage />,
            },
            {
                path: '/dev/ranking',
                element: <DevRankingPage />,
            },
            {
                path: '/not-found',
                element: <NotFound />,
            },
            {
                path: '*',
                element: <NotFound />,
            },
        ],
    },
]);
